import { defineStore } from "pinia";

export const useProjectsSearchStore = defineStore("projectsSearch", {
  state: () => ({
    filters: null,
  }),
  actions: {
    saveFilters(filters) {
      this.filters = { ...filters };
    },
    handleNavigation(to, from) {
      const opensProject = from.name === "projects" && to.name === "show-projects";
      const returnsFromProject = from.name === "show-projects" &&
        (to.name === "projects" || to.name === "show-projects");

      if (!opensProject && !returnsFromProject) this.$reset();
    },
  },
});
